import React from "react";

import { useAuthenticator } from "@aws-amplify/ui-react";
import { Flex, Img, Text, Menu, MenuButton, MenuList, MenuItem, IconButton, Divider } from "@chakra-ui/react";
import { Link } from "react-router-dom";

import arupRedLogo from "assets/images/arup_red.svg";
import { useAppSelector } from "store/store";

const ENV_BANNERS: Record<string, { label: string; color: string; bodyBg: string } | undefined> = {
	"dev.aite.dhub.arup.com": { label: "DESARROLLO (entorno de pruebas)", color: "blue.400", bodyBg: "#DBF2FF" }, // blue.lightest
	//localhost: { label: "LOCAL (entorno local)", color: "blue.400", bodyBg: "#DBF2FF" },
};

export const Topbar: React.FC = () => {
	const { signOut } = useAuthenticator((context) => [context.signOut]);
	const userEmail = useAppSelector((state) => state.user.userEmail);
	const firstName = userEmail ? userEmail[0].toUpperCase() : "";
	const envBanner = ENV_BANNERS[window.location.hostname];

	React.useEffect(() => {
		if (envBanner) {
			document.title = `Gestor de Activos - ${envBanner.label}`;
			document.body.style.backgroundColor = envBanner.bodyBg;
		}
	}, [envBanner]);

	return (
		<Flex
			width="100%"
			height="3rem"
			backgroundColor={envBanner?.color ?? "pureWhite"}
			alignItems="center"
			justifyContent="space-between"
			padding="0 2rem"
			zIndex="3"
		>
			<Flex as={Link} to={"/"} alignItems="center">
				<Text ml="1rem" pt=".15rem" fontFamily="heading">
					Gestor de Activos
				</Text>
				{envBanner && (
					<Text
						ml="0.75rem"
						px="0.5rem"
						py="0.15rem"
						fontSize="body3"
						fontWeight="bold"
						color="pureBlack"
						backgroundColor="pureWhite"
						borderRadius="full"
					>
						{envBanner.label}
					</Text>
				)}
			</Flex>
			<Flex alignItems="center" gap="1rem">
				<Img src={arupRedLogo} alt="Arup Red Logo" />
				<Menu>
					<MenuButton
						as={IconButton}
						aria-label="Perfil de usuario"
						icon={
							<Flex
								w="1.75rem"
								h="1.75rem"
								borderRadius="full"
								bg="green.500"
								alignItems="center"
								justifyContent="center"
							>
								<Text fontSize="0.85rem" fontWeight="bold" color="white">
									{firstName || "?"}
								</Text>
							</Flex>
						}
						variant="ghost"
						size="sm"
						borderRadius="full"
					/>
					<MenuList>
						{userEmail && (
							<>
								<MenuItem isDisabled fontSize="sm" color="gray.500">
									{userEmail}
								</MenuItem>
								<Divider />
							</>
						)}
						<MenuItem onClick={signOut} color="red.500">
							Cerrar sesión
						</MenuItem>
					</MenuList>
				</Menu>
			</Flex>
		</Flex>
	);
};
